import { ParamKeyEnum } from './dashboard-param-key-enum'

export type DashboardDataQuery = {
  [ParamKeyEnum.Curriculum]?: string[]
  [ParamKeyEnum.CourseTitle]?: string[]
  [ParamKeyEnum.CourseLevel]?: string[]
  [ParamKeyEnum.SpaceId]?: string[]
  [ParamKeyEnum.Page]?: string
  [ParamKeyEnum.Size]?: string
  [ParamKeyEnum.SortBy]?: string
  [ParamKeyEnum.SortOrder]?: string
  startDate?: string
  endDate?: string
  fullDataType?: string
  fullDataSelected?: string
}
